import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { initialStateSlice } from "../../initialStateSlice";
// import { fetchAuthPost } from "../../../functions/functions";
import api from "../../../routes/api";
import { fetcher } from "../../../apis";

const countrySlice = createSlice({
  name: "country",
  initialState: initialStateSlice,
  reducers: {
    set_country: (state, action) => {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(load_country.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(load_country.fulfilled, (state, action) => {
        state.loading = false;
        state.body = action.payload;
      })
      .addCase(load_country.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export const { set_country } = countrySlice.actions;
export default countrySlice;

export const load_country = createAsyncThunk(
  "reference/country/load_country",
  async (payload, { getState, dispatch }) => {
    // const result = await fetchAuthPost(api.address.readCountryList, {});
    const result = await fetcher({ route: "/address/country" });
    if (result.ok) {
      return result.json.data;
    } else {
      throw result.json?.message;
    }
  }
);
